(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("logoCustomization", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/theme/logo/logoCustomizationView.html",
            controller: ["frameworkService", "messageService", "tenantResource", "logoService", "$rootScope", "$scope", "$timeout", "ngJcropConfig", "Upload", "FILE_FORMATS", LogoCustomizationCtrl],
            controllerAs: "vm"
        };
        function LogoCustomizationCtrl(frameworkService, messageService, tenantResource, logoService, $rootScope, $scope, $timeout, ngJcropConfig, Upload, FILE_FORMATS) {
            var vm = this;
            vm.jcropData = {};
            vm.model = {};
            vm.saving = false;
            vm.loading = true;
            vm.acceptedFileTypes = FILE_FORMATS.image;
            vm.acceptedFileTypesFormated = vm.acceptedFileTypes.replace(/,/g, ", "); //Adds a space after each comma for better displaying
            //Configure JCrop Properties
            ngJcropConfig.logo = {};
            angular.extend(ngJcropConfig.logo, ngJcropConfig.default);
            ngJcropConfig.logo.jcrop = {
                bgColor: '#fff',
                minSize: [94, 94],
                maxSize: [1000, 0],
                maxHeight: 299.9,
                boxWidth: 320,
                boxHeight: 320,
                onChange: updateCrop,
                onSelect: updateCrop
            };
            ngJcropConfig.logo.previewImgStyle = {
                display: "none"
            };
            vm.jcropData.coords = [0, 0, 0, 0, 0, 0];
            tenantResource.getLogoCustomization(function (result) {
                loadCropArea(result);
            });
            vm.upload = function (file) {
                vm.file = file;
                if (file) {
                    file.upload = Upload.upload({
                        url: "api/tenants/logo/upload",
                        data: { file: file }
                    });
                    file.upload.then(function (response) {
                        $timeout(function () {
                            loadCropArea(response.data);
                            messageService.success("common.dropzone.uploadedFileMessage");
                            vm.file.progress = 0;
                        });
                    }, function (response) {
                        if (response.status > 0) {
                            messageService.error(response);
                        }
                        vm.file.progress = 0;
                    }, function (evt) {
                        file.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.save = function () {
                vm.saving = true;
                if (!vm.form.$valid) {
                    vm.showErrors = true;
                    vm.saving = false;
                    return;
                }
                //angular.extend(vm.model, vm.coords);
                vm.model.coordinates = vm.coords;
                tenantResource.cropLogo(vm.model, function (result) {
                    loadCropArea(result);
                    vm.saving = false;
                    messageService.success("settings.theme.logo.saved");
                    frameworkService.data.tenant.logoRedirectUrl = result.logoRedirectUrl;
                }, function () {
                    messageService.error("common.genericError");
                    vm.saving = false;
                });
            };
            function updateCrop(coords) {
                vm.coords = coords;
                $scope.$apply();
            }
            function loadCropArea(result) {
                var logoUrl = result.originalLogoUrl;
                vm.model.logoRedirectUrl = result.logoRedirectUrl;
                if (result.cropData)
                    vm.model.makeWhiteTransparent = result.cropData.makeWhiteTransparent;
                // Loading image to get the actual Width and Height
                var image = new Image();
                image.style.display = "none";
                image.onload = function () {
                    $scope.$apply(function () {
                        ngJcropConfig.logo.jcrop.trueSize = [image.naturalWidth, image.naturalHeight];
                        vm.jcropData.src = logoUrl;
                        var cropData = result.cropData;
                        if (!cropData)
                            vm.jcropData.coords = [0, 0, image.naturalWidth, image.naturalHeight, image.naturalWidth, image.naturalHeight];
                        else
                            vm.jcropData.coords = [cropData.coordinates.x, cropData.coordinates.y, cropData.coordinates.x2, cropData.coordinates.y2, cropData.coordinates.w, cropData.coordinates.h];
                        vm.loading = false;
                    });
                };
                image.onerror = function () {
                    vm.loading = false;
                };
                image.src = logoUrl;
                // Updating the top logo
                logoService.logo = result.logoUrl;
                //$rootScope.$broadcast("siteLogoChanged");
            }
        }
    });
}());
